/**
 * CookieConsent Component
 * GDPR cookie consent banner - shows at bottom of screen
 * Controlled via admin settings (enable/disable, custom message)
 * Stores acceptance in localStorage
 */
import React, { useState, useEffect } from 'react';

const CookieConsent = ({ API, isDarkMode }) => {
  const [visible, setVisible] = useState(false);
  const [settings, setSettings] = useState(null);

  useEffect(() => {
    if (localStorage.getItem('cookie_consent_accepted')) return;

    const loadSettings = async () => {
      try {
        const response = await fetch(`${API}/settings`);
        const data = await response.json();
        if (data.cookie_consent_enabled) {
          setSettings(data);
          setVisible(true);
        }
      } catch (error) {
        // If settings fail, don't show banner
      }
    };
    loadSettings();
  }, [API]);

  const handleAccept = () => {
    localStorage.setItem('cookie_consent_accepted', Date.now().toString());
    setVisible(false);
  };

  if (!visible || !settings) return null;

  const message = settings.cookie_consent_message || 'We use cookies to enhance your experience.';
  const learnMoreLink = settings.cookie_consent_link || '/privacy-policy';

  return (
    <div className="fixed bottom-0 left-0 right-0 z-[200] p-4">
      <div className={`max-w-lg mx-auto rounded-2xl p-4 shadow-2xl border backdrop-blur-sm ${
        isDarkMode
          ? 'bg-gray-900/95 border-gray-700 text-gray-300'
          : 'bg-white/95 border-gray-200 text-gray-600'
      }`}>
        <div className="flex flex-col sm:flex-row items-start sm:items-center gap-3">
          <div className="flex-1">
            <p className="text-sm leading-relaxed">
              {message}{' '}
              <a
                href={learnMoreLink}
                className="text-blue-600 hover:underline font-medium"
                target="_blank"
                rel="noopener noreferrer"
              >
                Learn more
              </a>
            </p>
          </div>
          <button
            onClick={handleAccept}
            className="flex-shrink-0 px-5 py-2 bg-blue-600 text-white text-sm font-semibold rounded-xl hover:bg-blue-700 transition-colors"
          >
            Accept
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
